var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.668 3.662h7.562a12 12 0 0 1 11.762 12.002v12.323q.063.82 0 1.64v22.364L79.99 75.996H21.98L7.976 51.991V23.986a4.32 4.32 0 0 1 4.56-4h3.441v-4.322A12 12 0 0 1 27.98 3.662h7.442a12 12 0 0 1 16.563-.56 12 12 0 0 1 16.683.56m-43.277 9.173a4 4 0 0 0-1.171 2.83l-.24 4.32h8.001v-8.321h-3.76a4 4 0 0 0-2.83 1.171m11.671 21.353q.602-.48 1.08-1.08a8 8 0 0 0 1.84-5.121H15.979v8.001h16.003a8 8 0 0 0 5.081-1.8m2.92-22.204v8.001h8.002v-8.001a4 4 0 1 0-8.001 0m22.834 22.832a4 4 0 0 0 1.171-2.829V11.985a4 4 0 1 0-8.001 0v20.004a4 4 0 0 0 6.83 2.828m14.83-1.171a8 8 0 0 0 2.344-5.658V15.664a4 4 0 0 0-4-4h-4.001v20.324a12 12 0 0 1-.92 4h.92a8 8 0 0 0 5.658-2.343M24.36 93.656a8 8 0 0 1-2.343-5.658v-4h57.97v4a8 8 0 0 1-8 8.002H30.016a8 8 0 0 1-5.658-2.344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMma);
export default __webpack_public_path__ + "static/media/mma.6cf16a08d2a58cdae553f08849a6b32a.svg";
export { ForwardRef as ReactComponent };